module.exports = __webpack_public_path__ + "static/media/banner-critical.39ab37b6.svg";